import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Funciona para o meu tipo de produto?',
  answer: 'O método funciona para qualquer lembrancinha — comestível, planta, aromatizador, papel, objetos. As 40 ideias cobrem categorias diferentes justamente para isso.'
}, {
  question: 'O acesso é vitalício?',
  answer: 'Sim, você paga uma única vez e tem acesso para sempre, incluindo futuras atualizações.'
}, {
  question: 'Serve para quem está começando?',
  answer: 'Sim! É o melhor momento para começar, pois você já inicia com o olhar treinado para valorizar seu produto desde o primeiro dia.'
}, {
  question: 'Preciso de materiais caros?',
  answer: 'Não. A maioria dos exemplos usa materiais que custam menos de R$2 por unidade. O Efeito Boutique™ é sobre escolha, combinação e apresentação — não sobre custo do material.'
}, {
  question: 'Como recebo o acesso?',
  answer: 'Imediatamente após a confirmação do pagamento, você recebe um e-mail com login e senha para acessar a plataforma do curso.'
}];
export function FAQSection() {
  return <section className="py-8 md:py-12 bg-white" data-id="element-100">
      <div className="max-w-3xl mx-auto px-6" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-8 text-center" data-id="element-102">
          Dúvidas frequentes
        </h2>

        <div className="space-y-4" data-id="element-103">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-104" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-stone-100 last:border-0" data-id="element-105">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-5 flex items-center justify-between text-left hover:text-brand-600 transition-colors" data-id="element-106">
        <span className="font-medium text-base md:text-lg text-stone-900" data-id="element-107">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-stone-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-108" />
      </button>
      <AnimatePresence data-id="element-109">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-110">
            <p className="pb-5 text-sm md:text-base text-stone-600 leading-relaxed" data-id="element-111">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}